{
    "name": "valk-timer-app",
    "version": "4.16.0",
    "private": true,
    "type": "module",
    "scripts": {
        "start": "node server/prebuild.ts && vite",
        "prebuild": "node server/prebuild.ts",
        "build": "npm run typecheck && vite build",
        "preview": "vite preview",
        "typecheck": "tsc --noEmit && tsc --noEmit -p tsconfig.node.json && tsc --noEmit -p tsconfig.sw.json",
        "lint": "eslint --fix ./src ./server eslint.config.ts jest.config.ts vite.config.ts",
        "test": "jest --watchAll=false --maxWorkers=33%",
        "test:ci": "jest --config ./jest.config.ts --collectCoverage --coverageDirectory=\"./coverage\" --ci --reporters=default --reporters=jest-junit --watchAll=false",
        "coverage": "jest --coverage --watchAll=false --maxWorkers=33%"
    },
    "dependencies": {
        "@reduxjs/toolkit": "^2.2.7",
        "@sentry/browser": "^11.7.0",
        "classnames": "^2.5.1",
        "date-fns": "^4.4.0",
        "date-fns-tz": "^3.2.0",
        "keyboard-event-key-type": "^1.5.0",
        "react": "^19.3.0",
        "react-dom": "^19.3.0",
        "react-redux": "^9.3.0",
        "usehooks-ts": "^3.1.1"
    },
    "devDependencies": {
        "@eslint/js": "^9.39.4",
        "@stylistic/eslint-plugin": "^5.10.0",
        "@types/eslint-plugin-jsx-a11y": "^6.10.1",
        "@types/jest": "^30.0.0",
        "@types/node": "^26.6.5",
        "@types/react": "^19.3.0",
        "@types/react-dom": "^19.3.0",
        "@vitejs/plugin-react": "^6.1.2",
        "eslint": "^9.39.4",
        "eslint-config-prettier": "^10.1.8",
        "eslint-import-resolver-typescript": "^4.4.4",
        "eslint-plugin-import": "^2.32.0",
        "eslint-plugin-jest": "^29.15.2",
        "eslint-plugin-jsx-a11y": "^6.10.2",
        "eslint-plugin-react": "^7.37.5",
        "eslint-plugin-react-hooks": "^7.1.1",
        "eslint-plugin-simple-import-sort": "^14.0.0",
        "eslint-plugin-unicorn": "^65.0.1",
        "globals": "^17.6.0",
        "jest": "^30.5.2",
        "jest-environment-jsdom": "^30.5.2",
        "jest-junit": "^17.0.0",
        "jiti": "^2.7.0",
        "sass-embedded": "^1.105.1",
        "ts-jest": "^29.4.14",
        "typescript": "~6.0.3",
        "typescript-eslint": "^8.59.4",
        "vite": "^8.3.4"
    },
    "engines": {
        "node": "^20.19.0 || >=22.12.0"
    },
    "overrides": {
        "@istanbuljs/load-nyc-config": {
            "js-yaml": "^4.1.1"
        }
    }
}
